import { memo, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorValues, ModalProps } from 'Types';
import { ModalBox, FontAwesome } from 'Elements';

interface Props extends ModalProps {
	title: string;
}

export const ModalBoxAddressMessage: FC<Props> = memo(({ isOpen, onClose }) => {
	const { t } = useTranslation();
	return (
		<ModalBox isOpen={isOpen} onClose={onClose}>
			<header className="d-flex flex-column align-items-center text-center">
				<FontAwesome
					icon="triangle-exclamation"
					size="6x"
					color={ColorValues.yellow}
					className="mb-3"
				/>
				<p className="text-gray-3 mt-2">
					{t('text.the-address-not-valid-message')}
				</p>
				<a
					className="ms-2 fs-base text-primary fw-600"
					href="/my-business-partner/address">
					{t('text.edit-address')}
				</a>
			</header>
		</ModalBox>
	);
});

ModalBoxAddressMessage.displayName = 'ModalBoxAddressMessage';
